<template>
    <div v-if="show && loaded" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="popup-form">
                <NevsTextField v-model="data.email" :error="validation.email"
                               :label="$LANG.Get('fields.email')"></NevsTextField>
                <NevsSelect v-model="data.customer_id" :ajax="'select/customers'"
                            :error="validation.customer_id"
                            :label="$LANG.Get('fields.customer')"></NevsSelect>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()">
                    <i class="fa-solid fa-times"></i>
                    {{ $LANG.Get('buttons.cancel') }}
                </NevsButton>
                <NevsButton class="success" @click="saveClick()">
                    <i class="fa-solid fa-floppy-disk"></i>
                    {{ $LANG.Get('buttons.save') }}
                </NevsButton>&nbsp;
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";

export default {
    name: "ModalActivityPreviewAccess",
    components: {NevsTextField, NevsSelect, NevsButton},
    data() {
        return {
            data: {
                email: '',
                customer_id: null
            },
            validation: {
                email: '',
                customer_id: ''
            },
            loaded: false
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        accessId: {
            type: Number,
            default: null,
        }
    },
    emits: ['done'],
    watch: {
        'show'() {
            this.loaded = false;
            this.data = {
                email: '',
                customer_id: null
            };
            this.validation = {
                email: '',
                customer_id: ''
            };
            if (this.show && this.accessId != null) {
                let vm = this;
                this.$API.APICall('get', 'activities-preview-access/' + this.accessId, {}, (data, success) => {
                    if (success) {
                        vm.data.email = data.activity_preview_access.email;
                        vm.data.customer_id = data.activity_preview_access.customer_id;
                        vm.$nextTick(() => {
                            vm.loaded = true;
                        });
                    }
                });
            } else if (this.show) {
                this.$nextTick(() => {
                    this.loaded = true;
                });
            }
        }
    },
    methods: {
        cancelClick() {
            this.$emit('done', false);
        },
        saveClick() {
            let valid = true;

            if (this.data.email === '' || this.data.email === null) {
                valid = false;
                this.validation.email = this.$LANG.Get('labels.mandatoryField');
            } else {
                if (!this.$HELPERS.CheckEmail(this.data.email)) {
                    valid = false;
                    this.validation.email = this.$LANG.Get('labels.invalidEmailAddress');
                } else {
                    this.validation.email = '';
                }
            }

            if (this.data.customer_id == null) {
                valid = false;
                this.validation.customer_id = this.$LANG.Get('labels.customerIdMissing');
            } else {
                this.validation.customer_id = '';
            }

            if (valid) {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (this.accessId != null) {
                    action = 'put';
                    addition = '/' + this.accessId;
                }
                this.$API.APICall(action, 'activities-preview-access' + addition, this.data, (data, success) => {
                    if (success) {
                        vm.$emit('done', true);
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                });
            }
        }
    }
}
</script>

<style scoped>
.popup-form {
    padding: 10px;
}

.nevs-popup {
    max-width: 500px;
}
</style>
